import md5 from "md5";

import { Constant } from "../../constants";
import { ApiConfig } from "../../configuration";

const hash = (value) => {
    const serverDateTime = localStorage.getItem(Constant.localStorageKey.serverDate)
    if(serverDateTime){
        return md5(`${value}${ApiConfig.key}${serverDateTime}`)
    }

    const year = new Date().getFullYear()
    const month = new Date().getMonth()+1
    const formattedMonth = month.toString().length === 1 ? '0'+month : month
    const day = new Date().getDate()
    const formattedDay = day.toString().length === 1 ? '0'+day : day
    return md5(`${value}${ApiConfig.key}${year}-${formattedMonth}-${formattedDay}`)
}

export {
    hash
}